import { render, staticRenderFns } from "./OrderConfirmation-Footer.vue?vue&type=template&id=0f9cbd0e&"
import script from "./OrderConfirmation-Footer.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation-Footer.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmation-Footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports